import React from "react";
import Tooltip from "@material-ui/core/Tooltip";
import { BsInfoCircle } from "react-icons/bs";
import "./tooltip-generic.css";

const TooltipGeneric = ({
	content,
	ariaLabel = "Mais informações",
	placement = "top",
	iconSize = 14
}) => {
	return (
		<Tooltip
			title={(
				<span className="tooltip-generic__content">
					{content}
				</span>
			)}
			arrow
			placement={placement}
			enterDelay={100}
			leaveDelay={100}
		>
			<span
				className="tooltip-generic__trigger"
				tabIndex={0}
				aria-label={ariaLabel}
			>
				<BsInfoCircle size={iconSize} />
			</span>
		</Tooltip>
	);
};

export default TooltipGeneric;